export default __webpack_public_path__ + "static/poster-3461744651f864c749031871677b56bf.png";